import { CountryCodes } from './../../i18n/CountryCodes';

export class ValidatorUtilityHandler {
    getCompanyNumberMinLength(countryCode: string): number {
        const currentCountry = CountryCodes.find((c) => c.code === countryCode.toLowerCase());
        return currentCountry ? currentCountry.companyNumberMinLength : 0;
    }

    getCompanyNumberMaxLength(countryCode: string): number {
        const currentCountry = CountryCodes.find((c) => c.code === countryCode.toLowerCase());
        return currentCountry ? currentCountry.companyNumberMaxLength : 30;
    }
}
